import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const SafariInclusions = () => {
  const packageInclusions = [
    { id: 1, label: "Flight Tickets", selection: 1 },
    { id: 2, label: "Hotel Stay", selection: 2 },
    { id: 3, label: "Local Transport", selection: 3 },
  ];

  const mealsLabel = "Breakfast, Lunch, Dinner";
  const packageDetails = {
    package_inclusion: "This package includes accommodation and transport.",
    package_exclusion: "Flights are not included in the package."
  };

  return (
    <div id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" className="tab-pane  accordion-item mb-3 ">
      <div className="card bg-set accordion-collapse  card_bodyPadding">
        <div className="card-body p-3">
          <Container>
            <Row>
              <Col md={12}>
                <div className="form-group">
                  {packageInclusions.map((item) => (
                    <Row key={item.id} className="mb-2">
                      <Col md={3} sm={4}>
                        <ul className="mb-0 px-3">
                          <li>
                            <label className="control-label font_sizes">
                              {item.label}
                            </label>
                          </li>
                        </ul>
                      </Col>
                      <Col md={9} sm={8}>
                        <span style={{ color: "#707070" }}>
                          {item.selection === 1
                            ? "Included"
                            : item.selection === 2
                              ? "Not Included"
                              : "Optional"}
                        </span>
                      </Col>
                    </Row>
                  ))}

                  <Row className="mb-2">
                    <Col md={3} sm={4}>
                      <ul className="mb-0 px-3">
                        <li>
                          <label className="control-label font_sizes">Meals</label>
                        </li>
                      </ul>
                    </Col>
                    <Col md={9} sm={8}>
                      <span style={{ color: "#707070" }}>{mealsLabel}</span>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            <Row className="inclusions">
              <Col md={12} className="pt-3">
                <div className="itenary_text font_familydd">
                  <p className="mb-2">{packageDetails.package_inclusion}</p>
                </div>
                <div className="itenary_text">
                  <p className="mb-2">{packageDetails.package_exclusion}</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default SafariInclusions;
